import { PropsWithChildren } from 'react';

import { Button, ButtonProps } from '@chakra-ui/react';

import { publicEnv } from '~/features/environment/public';
import { useBaseUrl } from '~/hooks/use-base-url';

export function SignUpButtonLink(props: PropsWithChildren<ButtonProps>) {
  const baseUrl = useBaseUrl();
  const signUpUrl = `${publicEnv.NEXT_PUBLIC_AUTH_URL}/sign-up`;

  return (
    <Button
      {...props}
      onClick={(e) => {
        props?.onClick?.(e);
        const url = `${signUpUrl}?next=${baseUrl}`;
        if (e.metaKey || e.ctrlKey) {
          window.open(url, '_blank');
          return;
        }
        window.location.href = url;
      }}
    />
  );
}
